import type { Highlighter } from '@highlight-cp/highlighter-api';
import { highlighterApi } from '@highlight-cp/highlighter-api';

export const highlighterAccountApi = highlighterApi.injectEndpoints({
  // Hot reload runs this again; without it RTK keeps the first definition.
  overrideExisting: true,
  endpoints: (build) => ({
    // GET /api/account/highlighter-account; the account mutations already invalidate this tag.
    getHighlighterAccount: build.query<Highlighter, void>({
      query: () => ({ url: 'account/highlighter-account' }),
      providesTags: ['HighlighterAccounts'],
    }),
  }),
});

export const { useGetHighlighterAccountQuery } = highlighterAccountApi;
